import { useEffect, useState } from "react";
import apiClient from "../utils/apiClient";
import { useNavigate } from "react-router-dom";
import ModalContainer from "../../containers/shared/ModalContainer";
import NormalButton from "../shared/NormalButton";
import DateField from "../shared/DateField";
import moment from "moment/moment";

export default function PerventiveTableRowActions({id,hasReports,nextScheduleDate,handleChangeNextScheduleDate,closeEditModal}) {



    const [newNextScheduleDate, setNewNextScheduleDate] = useState(nextScheduleDate);
    const [isChangdDateDisabled, setIsChangdDateDisabled] = useState(true);
    const [showEditNextDate, setShowEditNextDate] = useState(false);
    const [showActions, setShowActions] = useState(false);
    const navigate = useNavigate();

    const downloadLastReport = async () => {
        try {
        const response = await apiClient.get(`/b-preventive-visits/${id}/export-last-report`,{
              responseType: 'blob',
            });
        if(response?.data) {
           let fileURL = URL.createObjectURL(response.data);
              let fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.click();
              setShowActions(false);
        } else {

        }
      } catch(err) {}
    }

    const goToDetailsPage = () => {
        navigate(`/ar/preventive-visits/${id}`)
    }

    const handleCloseModal = () => {
        setShowEditNextDate(false);
    }

    useEffect(()=>{
        if(moment(nextScheduleDate).diff(moment(newNextScheduleDate),'days') !== 0) {
            setIsChangdDateDisabled(false);
        } else {
            setIsChangdDateDisabled(true);
        }
    },[nextScheduleDate, newNextScheduleDate])

    const handleClickEditButton = () => {
        setShowEditNextDate(true);
        setShowActions(false);
    }

    useEffect(()=>{
        if(closeEditModal === id) {
            setShowEditNextDate(false);
        }
    },[closeEditModal,id])
    
  
    return (
        <div className="relative">
            <div className="cursor-pointer z-0 select-none w-[16px] h-[16px] !bg-center !bg-contain" style={{background:"url('/assets/images/more.svg')"}} onClick={()=>setShowActions(!showActions)}></div>
            {showActions && <div className="absolute z-[1] shadow-[0px_25px_35px_0px_rgba(0,0,0,0.03)] top-[16px] left-[8px] rounded-b-[8px] w-[170px] bg-white border border-grey-300 py-[8px] px-[12px] text-center text-grey-600 font-[500] text-[14px]">
                <ul>
                    <li className="text-start leading-[48px] px-[8px] cursor-pointer select-none font-[500] text-[16px] border-b-[1px] border-b-grey-200" onClick={()=>goToDetailsPage()}>التفاصيل</li>
                    <li className={`text-start leading-[48px] px-[8px] cursor-pointer select-none font-[500] text-[16px] ${hasReports ? 'border-b-[1px] border-b-grey-200' : ''}`} onClick={()=>handleClickEditButton(true)}>تغيير موعد الزيارة</li>
                    {hasReports && <li className="text-start leading-[48px] px-[8px] cursor-pointer select-none font-[500] text-[16px]" onClick={()=>downloadLastReport()}>تحميل أخرتقرير</li>}
                </ul>
            </div>}

            {showEditNextDate && <ModalContainer noOverFlow={true} heading="تغيير موعد الزيارة" handleCloseModal={handleCloseModal}>
                        <div className="">
                            <DateField label={'موعد الزيارة'} placeholder={'اختر موعد الزيارة'} value={newNextScheduleDate} error={''} errorMessage={''} translateError={true} onChange={(date)=>{ setNewNextScheduleDate(date)}} />
                        </div>
                        <div className="text-end">
                          <div className="text-grey-400 text-[18px] font-[600] inline-block cursor-pointer select-none me-[50px]" onClick={handleCloseModal}>إلغاء</div>
                          <NormalButton label={'تعديل'} onClick={()=>handleChangeNextScheduleDate(id,newNextScheduleDate)} isDisabled={isChangdDateDisabled} />
                        </div>

                    </ModalContainer>}
        </div>
    )
};

